import HttpRequestService from "../../serviceLayer/httpProtocol/HttpRequestService"
import TargetApiUrlAndPath from "../../utils/webApi/TargetApiUrlAndPath";
import HttpResponseStatusCode from "../../utils/httpProtocol/HttpStatusCode";
import LocalStorageDataStorer from "../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../dataAccessLayer/localStorage/LocalStorageKey";

const getAllResourcesAndActions = function(resourcesAndActionsPageCallback){
    const url =  HttpRequestService.getUrl(TargetApiUrlAndPath.API_RESOURCES_PATH);
    HttpRequestService.GETMethod(url, (httpResponse)=>{
        processHttpResponseGetAllResourcesAndActions(httpResponse);
        resourcesAndActionsPageCallback(httpResponse);
    });
}

//#region Private Functions BEGIN
function processHttpResponseGetAllResourcesAndActions(httpResponse){

    if(httpResponse.code === HttpResponseStatusCode._200ok.code){
        //console.log("ResourcesManager-processHttpResponseGetAllResourcesAndActions-httpResponse", httpResponse);

        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.apiResourcesAndActions, httpResponse.payload.APIResourcesAndActions);
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.customerResourcesAndActions, httpResponse.payload.CustomerResourcesAndActions);
        LocalStorageDataStorer.setItemInLocalStorage(LocalStorageKey.frontEndResourcesAndActions, httpResponse.payload.FrontEndResourcesAndActions);
    }
}

//#region Private Functions END


const ResourcesManager = Object.freeze({
    getAllResourcesAndActions : getAllResourcesAndActions
});

export default ResourcesManager;